import React, { useEffect } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import TablerLayout from "../components/layout/TablerLayout";
import FullWidthButton from "../components/buttons/FullWidthButton";
import dataService from "../services/dataService"; // API híváshoz
import { isSupervisor } from "../services/userService";
import { IconSettings } from "@tabler/icons-react";

const Home = () => {
	const { order, replaceOrder, updateOrder, resetOrder, setOrderId } = useOrder();
	const navigate = useStepNavigate();

	useEffect(() => {
		const savedStep = localStorage.getItem("step_page");
		const savedOrderSzam = localStorage.getItem("hmeliorder_szam");
		const savedOrderData = localStorage.getItem("order");

		let partnerSzam = null;
		if (savedOrderData) {
			try {
				const orderObj = JSON.parse(savedOrderData);
				partnerSzam = orderObj?.partner?.partner_szam;
			} catch (e) {
				partnerSzam = null;
			}
		}

		if (
			savedStep &&
			savedOrderSzam &&
			partnerSzam &&
			(!order?.hmeliorder?.hmeliorder_szam || order.hmeliorder.hmeliorder_szam !== Number(savedOrderSzam))
		) {
			dataService.getOrder(savedOrderSzam, partnerSzam).then((response) => {
				if (response.data?.status === "ok" && response.data?.data) {
					replaceOrder(response.data.data);
					setOrderId(Number(savedOrderSzam));
					navigate("/" + savedStep);
				} else {
					// Ha nincs ilyen rendelés, töröljük a localStorage-t
					localStorage.removeItem("step_page");
					localStorage.removeItem("hmeliorder_szam");
					localStorage.removeItem("order");
				}
			});
		}
	}, [order, replaceOrder, setOrderId, navigate]);

	const handleNewOrder = () => {
		resetOrder();
		updateOrder({
			...order,
			hmeliorder: {
				...order.hmeliorder,
				hmeliorder_szam: 1,
			}
		});
		setOrderId(1);
		navigate('/MeretfelveteliHely');
	};

	const isUserSupervisor = isSupervisor();

	return (
		<TablerLayout title="Üdvözöljük az Elitcipő rendelési rendszerében!">
			<div className="row justify-content-center">
				<div className="col-md-10 text-center mb-4">
					<FullWidthButton 
						onClick={handleNewOrder} 
						height="100px"
						plusClass="fs-3"
					>
						Új rendelés
					</FullWidthButton>
				</div>
				<div className="col-md-10 text-center mb-4">
					<FullWidthButton 
						onClick={() => navigate('/Rendelesek')}
						height="100px"
						plusClass="fs-3"
					>
						Megrendelés betöltése
					</FullWidthButton>
				</div>
				{/* {isUserSupervisor && (
					<div className="col-md-10 text-center mb-4">
						<FullWidthButton 
							onClick={() => navigate('/Admin')}
							height="100px"
							plusClass="fs-3 btn-success d-flex align-items-center justify-content-center gap-2 border-0"
							style={{ color: "white", backgroundColor: "orange" }}
						>
							<IconSettings size={24} />
							<span>Admin oldal</span>
						</FullWidthButton>
					</div>
				)} */}
			</div>
		</TablerLayout>
	);
}

export default Home;